<template>
  <div class="d-flex text-center justify-content-center align-items-center h-100">
    チャットを選択して下さい
  </div>
</template>
<script>
export default {};
</script>
